exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollbar-wrapper__scrollbar-wrapper__3ud2S{overflow:auto;width:100%;height:100%}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar{background:transparent}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar:vertical{width:14px}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar:horizontal{height:14px}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb{background-color:rgba(242,123,81,.3);background-clip:padding-box;border:4px solid transparent;border-radius:7px;transition:background-color .2s}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb:active,.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb:hover{background-color:#f27b51}", ""]);

// exports
exports.locals = {
	"scrollbar-wrapper": "scrollbar-wrapper__scrollbar-wrapper__3ud2S",
	"scrollbarWrapper": "scrollbar-wrapper__scrollbar-wrapper__3ud2S"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/scrollbar-wrapper/scrollbar-wrapper.styl
// module id = 1316
// module chunks = 0 1 2 3